var map = {
	"./ADP.png": 12160,
	"./BILL.png": 97347,
	"./BOT.png": 7710,
	"./BOX.png": 96475,
	"./CCHAD.png": 26304,
	"./CCHPM.png": 39685,
	"./CDB.png": 23990,
	"./CSG.png": 69445,
	"./D365.png": 20602,
	"./DOCIT.png": 63120,
	"./DPBX.png": 67850,
	"./EXL.png": 78468,
	"./EXP.png": 74025,
	"./GUS.png": 2370,
	"./HBSPT.png": 23042,
	"./IPE.png": 52763,
	"./IRISTR.png": 65619,
	"./IRISTROP.png": 26868,
	"./K1EXT.png": 68853,
	"./LCT.png": 37545,
	"./LKDIN.png": 58553,
	"./MDM.png": 26265,
	"./OCR.png": 68887,
	"./PCS.png": 2561,
	"./PCTIGN.png": 79107,
	"./PCX.png": 35376,
	"./PE.png": 1443,
	"./PROC.png": 45059,
	"./QCK.png": 61103,
	"./QUICKBOOK.png": 16055,
	"./REDTAIL.png": 37974,
	"./SAP.png": 88851,
	"./SFSD.png": 51676,
	"./SGD.png": 38298,
	"./SGIT.png": 54816,
	"./SHFL.png": 20082,
	"./SHRPT.png": 12636,
	"./SLFC.png": 53682,
	"./SLK.png": 44239,
	"./SMS.png": 12068,
	"./SSCIL.png": 76723,
	"./STAR.png": 86589,
	"./TAL.png": 72352,
	"./TWL.png": 8371,
	"./WD.png": 45435,
	"./WLTN.png": 54191,
	"./X.png": 79986,
	"./XCM.png": 92717,
	"./XRO.png": 55587,
	"./ZEN.png": 2307,
	"./firmadmin.png": 82800,
	"./myapps.png": 89806,
	"./myflows.png": 93072,
	"./myforms.png": 77145,
	"./mykones.png": 24822,
	"./recommendations_1.png": 97582,
	"./recommendations_2.png": 69798,
	"./recommendations_3.png": 67340,
	"./superadmin.png": 57145,
	"./undefined.png": 15227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50561;